// extracted by mini-css-extract-plugin
module.exports =  {"rotating-arc":"_6c97079b1b--rotating-arc--FcLu5","rotate":"_6c97079b1b--rotate--p1VpF","arc-path":"_6c97079b1b--arc-path--zY91O"};